<template>
    <div>
        <div class="ml-3 mt-2" style="position: absolute; z-index: 2">
            <div class="btn-group">
                <button class="btn" @click="setChartType('tree')"
                :class="{ 'btn-primary' : chartType === 'tree', 'btn-outline-primary' : chartType !== 'tree'}">{{$t('tree-map')}}</button>
                <button class="btn" @click="setChartType('radialTree')"
                :class="{ 'btn-primary' : chartType !== 'tree', 'btn-outline-primary' : chartType === 'tree'}">{{$t('radial-tree-map')}}</button>
            </div>
        </div>
        <div 
            :style="options.wrapperStyle"
            @wheel.stop="onWheel" 
            ref="chartWrapper"
            class="mt-3"
        >
            <div
                ref="chart" 
                :style="{
                    ...options.chartStyle, 
                    transform: `scale(${this.zoom})`,
                }"
                @mousedown="dragMouseDown"
            >
            </div>
        </div>
    </div>
</template>
<script>
import * as d3 from 'd3';

export default {
    props:{
        options: Object,
        /*wrapperStyle: {
            type: Object,
            default: () => {
                position: 'fixed', 
                top:'0px', 
                bottom:'0',
                left: '0', 
                right: '300px', 
                overflow: 'hidden'
            }
        },*/
        zoomable: {
            type: Boolean,
            default: true
        },
        draggable: {
            type: Boolean,
            default: true
        },
        hierarchy: Object,
        isGraph:Boolean
    },
	components: {
	},
    data() {
        return {
            selectedNode: null,
            loaded: false,
            root: null,
            chartType: 'tree',
            svg: null,
            zoom: 1.0,
			positions: {
				clientX: undefined,
				clientY: undefined,
				movementX: 0,
				movementY: 0
			},
            dx:30,
            /*chartOptions: {
                options.zoomable ? zoomCSS : null, options.draggable : null ? 'cursor: move' 
            }*/
        }

    },
    mounted() {
        this.renderTree(this.hierarchy, {
            label: d => d.title,
            title: (d, n) => `${n.ancestors().reverse().map(d => d.data.title).join(".")}`,
            width: this.$refs.chart.offsetWidth,
            //height: this.$refs.chart.offsetHeight,
            chartType : this.chartType
            });

        this.loaded = true;

    },
    methods: {
        /**
        * These are all of the geometry methods we need to manipulate the dendogram
        *
        * 
        */
		onWheel: function (event) {
            if(!this.options.zoomable) return ;
			event.preventDefault();
			var newzoom = this.zoom - event.deltaY/1000;
			if(newzoom > 0.02){
				this.zoom = newzoom;
			}
			return false;
		},
		dragMouseDown: function (event) {

            if(!this.options.draggable) return; // Disable draf

			event.preventDefault();
			// get the mouse cursor position at startup:
			this.positions.clientX = event.clientX
			this.positions.clientY = event.clientY
			document.onmousemove = this.elementDrag
			document.onmouseup = this.closeDragElement
		},
		elementDrag: function (event) {
			event.preventDefault();
			this.positions.movementX = this.positions.clientX - event.clientX;
			this.positions.movementY = this.positions.clientY - event.clientY;
			this.positions.clientX = event.clientX;
			this.positions.clientY = event.clientY;
			// set the element's new position:
			this.$refs.chart.style.top = (this.$refs.chart.offsetTop - this.positions.movementY) + 'px'
			this.$refs.chart.style.left = (this.$refs.chart.offsetLeft - this.positions.movementX) + 'px'
		},
		closeDragElement () {
			document.onmouseup = null
			document.onmousemove = null
		},

    
        /**
        * This is the main matter of the component, it renders the dendogram
        *
        * The forthcoming code is based on the radial-tree and collapsible-tree scripts by Observable, Inc
        * Copyright 2022 Observable, Inc.
        * Released under the ISC license.
        * https://observablehq.com/@d3/collapsible-tree
        * https://observablehq.com/@d3/radial-tree
        * 
        * @param {(Object[]|Object)} data - The data to be processed.
        *   - If tabular: An array of objects where each object represents a row of data.
        *   - If hierarchical: A nested object structure representing a hierarchy.
        */

        renderTree(data, 
            { 
                path, // as an alternative to id and parentId, returns an array identifier, imputing internal nodes
                id = Array.isArray(data) ? d => d.id : null, // if tabular data, given a d in data, returns a unique identifier (string)
                parentId = Array.isArray(data) ? d => d.parentId : null, // if tabular data, given a node d, returns its parent’s identifier
                children, // if hierarchical data, given a d in data, returns its children
                tree = d3.tree, // layout algorithm (typically d3.tree or d3.cluster)
                separation = tree === d3.tree ? (a, b) => (a.parent == b.parent ? 1 : 2) / a.depth : (a, b) => a.parent == b.parent ? 1 : 2,
                sort, // how to sort nodes prior to layout (e.g., (a, b) => d3.descending(a.height, b.height))
                label, // given a node d, returns the display name
                title, // given a node d, returns its hover text
                link, // given a node d, its link (if any)
                linkTarget = "_self", // the target attribute for links (if any)
                width = 640, // outer width, in pixels
                height, // outer height, in pixels
                r = 3, // radius of nodes
                margin = 60, // shorthand for margins
                marginTop = 100, // top margin, in pixels
                marginRight = 100, // right margin, in pixels
                marginBottom = margin, // bottom margin, in pixels
                marginLeft = 100, // left margin, in pixels
                radius = Math.min(width - marginLeft - marginRight, width - marginTop - marginBottom) / 2, // outer radius
                padding = 1, // horizontal padding for first and last column
                fill = "#999", // fill for nodes
                stroke = "#555", // stroke for links
                strokeWidth = 1.5, // stroke width for links
                strokeOpacity = 0.4, // stroke opacity for links
                strokeLinejoin, // stroke line join for links
                strokeLinecap, // stroke line cap for links
                halo = "#fff", // color of label halo
                haloWidth = 3, // padding around the labels
                curve = d3.curveBumpX, // curve for the link
                chartType = this.chartType, //type of chart either tree or radialTree
            } = {}) {

            //If there is an existing chart, we erase it
            if (d3.select(this.$refs.chart)) d3.select(this.$refs.chart).selectAll('*').remove();
            
            // If id and parentId options are specified, or the path option, use d3.stratify
            // to convert tabular data to a hierarchy; otherwise we assume that the data is
            // specified as an object {children} with nested objects and use d3.hierarchy.

            this.root = path != null ? d3.stratify().path(path)(data)
                : id != null || parentId != null ? d3.stratify().id(id).parentId(parentId)(data)
                    : d3.hierarchy(data, children);

            // Sort the nodes.
            if (sort != null) this.root.sort(sort);

            // Compute labels and titles.
            const descendants = this.root.descendants();
            const L = label == null ? null : descendants.map(d => label(d.data, d));

            //Creates the SVG canvas
            const container = d3.select(this.$refs.chart);

            // Compute the layout
            this.dx = 10;
            const dy = width / (this.root.height + padding);

            if (chartType === 'tree') {
                tree().nodeSize([this.dx, dy])(this.root);
            } else {
                tree().size([2 * Math.PI, radius]).separation(separation)(this.root);
            }

            //Create the SVG container
            const svg = container
                .append("svg")
                .attr("style", "padding-left:50px;")
                .attr('width',"100%")
                .attr('height',"100%")
                //.attr('height', (x1 - x0) + marginTop + marginBottom)//.attr('height',height)
                .attr("font-family", "sans-serif")
                .attr("font-size", 10)
                .attr('viewBox', 
                    this.calcViewBox(//[originX, originY, width, height]
                        width, height, marginTop, marginBottom, marginRight, marginLeft, chartType,radius)
                    )
                .attr('preserveAspectRatio', 'xMidYMid meet');;

            //Choose what sort of linking function is going to be used
            const linkFunction = chartType === 'tree'
                ? d3.link(curve).x(d => d.y).y(d => d.x)
                : d3.linkRadial().angle(d => d.x).radius(d => d.y);

            //Create paths
            svg.append("g")
                .attr("fill", "none")
                .attr("stroke", stroke)
                .attr("stroke-opacity", strokeOpacity)
                .attr("stroke-linecap", strokeLinecap)
                .attr("stroke-linejoin", strokeLinejoin)
                .attr("stroke-width", strokeWidth)
                .selectAll("path")
                .data(this.root.links())
                .join("path")
                .attr("d", linkFunction)
                .classed('link', true);

            //Choose node transformation
            const nodeTransform = chartType === 'tree'
                ? d => `translate(${d.y},${d.x})`
                : d => `rotate(${d.x * 180 / Math.PI - 90}) translate(${d.y},0)`;

            //Create nodes
            const node = svg.append("g")
                .selectAll("a")
                .data(this.root.descendants())
                .join("a")
                .classed("node", true)
                .attr("xlink:href", link == null ? null : d => link(d.data, d))
                .attr("target", link == null ? null : linkTarget)
                .attr("transform", nodeTransform)
                .on('click', (d, i) => { 
                    this.highlightNodeAndPath(i);
                });

            node.append("circle")
                .attr("fill", d => d.children ? stroke : fill)
                .attr("r", r);

            if (title != null) {
                node.append("title")
                    .text(d => title(d.data, d));
            }

            //Choose text-anchor placement
            const textAnchorPlacement = chartType === 'tree'
                ? d => d.children ? "end" : "start"
                : d => d.x < Math.PI === !d.children ? "start" : "end";

            if (L) {
                if (chartType === 'tree') {
                    node.append("text")
                        .attr("dy", "0.32em")
                        .attr("x", d => d.children ? -6 : 6)
                        .attr("text-anchor", textAnchorPlacement)
                        .attr("paint-order", "stroke")
                        .attr("stroke", halo)
                        .attr("stroke-width", haloWidth)
                        .text((d, i) => this.truncateTitle(L[i],15));

                } else {
                    node.append("text")
                        .attr("transform", d => `rotate(${d.x >= Math.PI ? 180 : 0})`)
                        .attr("dy", "0.32em")
                        .attr("x", d => d.x < Math.PI === !d.children ? 6 : -6)
                        .attr("text-anchor", textAnchorPlacement)
                        .attr("paint-order", "stroke")
                        .attr("stroke", halo)
                        .attr("stroke-width", haloWidth)
                        .text((d, i) => this.truncateTitle(L[i],15))
                }
            }

            //This makes sure that the highlighted class is applied after the tree has rendered
            if(this.loaded){
                this.$nextTick(() => {
                	if(this.selectedNode){
                    	this.highlightNodeAndPath(this.selectedNode);
                    } 
            	});
            }
        },
        /**
         * This returns the ViewBox paramters for the SVG chart
         */
        calcViewBox(width, height, marginTop, marginBottom, marginRight, marginLeft, chartType, radius = null){
            // NOTE: X AND Y ARE SWAPPED FROM THEIR USUAL CARTESIAN ROLES!!!
            
            // Calculate maxima and minima for x (vertical) and y (horizontal)
            let x0 = Infinity, x1 = -x0, y0 = Infinity, y1 = -y0;
            this.root.each(d => {
                if (d.x > x1) x1 = d.x;
                if (d.x < x0) x0 = d.x;
                if (d.y > y1) y1 = d.y;
                if (d.y < y0) y0 = d.y;
            });

            
            // Calculate content dimensions
            width = y1-y0;

            if((x1-x0) > window.innerHeight) height = x1-x0; 
            else height = window.innerHeight
            
            // Define minimum dimensions to prevent "miniature" effect
            const minWidth = 400; 
            const minHeight = 300;

            // Calculate effective viewBox dimensions (ensure they meet minimums)
            const viewBoxWidth = Math.max(width + marginLeft + marginRight, minWidth);
            let viewBoxHeight = Math.max(height + marginTop + marginBottom, minHeight);

            // Calculate viewBox parameters based on layout and margins
            
            let viewBoxParams;
 

            if (chartType === 'tree') {

                const contentHeight = x1 - x0;
                const contentWidth = y1 - y0;
                const contentHeightWithMargins = contentHeight + marginTop + marginBottom;
                viewBoxHeight = Math.max(contentHeightWithMargins, minHeight);
                const extraSpace = viewBoxHeight - contentHeightWithMargins;
                
                // Center the content vertically including margins
                const viewBoxY = x0 - marginTop - (extraSpace / 2);
                const viewBoxX = y0 - marginLeft - (viewBoxWidth - (contentWidth + marginLeft + marginRight)) / 2; // Center horizontally

                viewBoxParams = [viewBoxX, viewBoxY, viewBoxWidth, viewBoxHeight];
            } else {
                const longestTitle = this.getLongestTitle(this.root.descendants()).data.title.length;
                viewBoxParams = [
                    -(width + longestTitle + marginLeft+radius)/2,
                    -(width + marginTop + longestTitle+radius)/2,
                    (width + longestTitle + marginLeft+radius),
                    (width + marginTop + longestTitle+radius)
                ];
                
            }

            return viewBoxParams;
        },
        resetPathAndNodes() {
            d3.selectAll('.node')
            .classed('highlighted', false);

            d3.selectAll('.link')
            .classed('highlighted', false);
        },
        /**
        * Highlights a node and its path from the root 
        *
        * @param {node} node - The node we want to highlight.
        */
        highlightNodeAndPath(node) {
            this.selectedNode = node;
            
            this.$emit('selectedNode', this.selectedNode.data ? this.selectedNode.data : this.selectedNode);

            const isD3Node = (obj) => {// Check if a node is a D3 node
                return obj && typeof obj === 'object' &&
                        'data' in obj && 'ancestors' in obj && typeof obj.ancestors === 'function';
            }

            // If it is not a D3 node, we make sure it is
            if(!isD3Node(node)) node = this.root.descendants().find(d => d.data.id === node.id);


            if (node) {
                // Store the IDs of the highlighted ancestor nodes  in an array
                const ancestorIds = node.ancestors().map(d => d.data.id);

                d3.selectAll('.node')
                    .classed('highlighted', d => ancestorIds.includes(d.data.id));

                // Add the highlighted class to the links where both source and target have matching IDs
                d3.selectAll('.link')
                    .classed('highlighted', d => (
                        ancestorIds.includes(d.source.data.id) 
                        && ancestorIds.includes(d.target.data.id)
                    ));
            }
        },

        /**
        * Highlights nodes whose chosen property matches the given value 
        *
        * @param {string} value - The value to match against the specified property.
        * @param {string} property - The property path to access. 
        * - It also allows nested properties (e.g., 'property1.property2')
        * 
        */
        highlightMatchingNodes(value, property) { 
        
            const propertyPath = property.split('.'); //In case we have nested properties

            // Filter nodes where the specified nested property includes the given value
            const nodesWithOutcome = this.root.descendants().filter(obj => {
                let data = obj.data;

                for (let prop of propertyPath) {
                    data = data[prop];
                    if (data === undefined) {
                        return false;
                    }
                }

                return Array.isArray(data) ? data.includes(String(value)) : false;
            });
            
            //Highlight the nodes 
            d3.select(this.$refs.chart)
                .selectAll('.node')
                .classed("highlighted", node => nodesWithOutcome.includes(node));

            // Create an empty array to store the highlighted nodes and links
            let highlightedNodes = [];
            let highlightedLinks = [];

            /* Function to traverse the path from a node to the root,
             this is inspired in the DFS Tree algorithm, c.f. https://www.thealgorists.com/Algo/TrackTraversedPathInDFS */
            const traversePathToRoot = (node) => {
                if (node) {
                    highlightedNodes.push(node); // Add the node to the highlighted nodes array
                    if (node.parent) {
                        const link = {
                            source: node.parent,
                            target: node,
                        };
                        highlightedLinks.push(link); // Add the link to the highlighted links array

                        traversePathToRoot(node.parent); // Recursively traverse to the parent node
                    }
                }
            };

            // Traverse the path from each node in nodesWithOutcome to the root
            nodesWithOutcome.forEach(node => {
                traversePathToRoot(node);
            });

            d3.select(this.$refs.chart)
                .selectAll(".link")
                .classed("highlighted", link => {
                    // Check if the link is part of the highlighted links array
                    return highlightedLinks.some(l => l.source === link.source && l.target === link.target);
                });
        },

        setChartType(type) {
            this.loaded = false;
            
            this.chartType = type; 

            // Update the chart.
            this.updateChart();

            this.loaded = true;
        },
        updateChart() {
            this.renderTree(this.hierarchy, {
                label: d => d.title,
                title: (d, n) => `${n.ancestors().reverse().map(d => d.data.title).join(".")}`, // hover text
                //link: () => `#`,
                width: this.$refs.chart.offsetWidth,
                //height: this.$refs.chart.offsetHeight,
                chartType: this.chartType,
            });
        },
        getUniqueNodeName(nodeName, index = 1) {
            const root = d3.hierarchy(this.hierarchy); //This makes it a D3 hierarchy
            const existingNodeNames = root.descendants().map((node) => node.data.name);

            let uniqueName = nodeName;
            if (existingNodeNames.includes(uniqueName)) {
                uniqueName = `${nodeName}-${index}`;
                if (existingNodeNames.includes(uniqueName)) {
                return this.getUniqueNodeName(nodeName, index + 1);
                }
            }

            return uniqueName;
        },
        
        getDepthFromNode(node) { //Adding 1 for bookkeeping and simplicity's sake
            if (!node) {
                return 0;
            }

            if (!node.children) {
                return 1;
            }

            // If the current node has children, recurse onto its offsrping
            const depths = node.children.map(child => this.getDepthFromNode(child));
            return 1 + Math.max(...depths);
        },
        getLongestTitle(nodes){
            if (!nodes || nodes.length === 0){
                return null;
            }

            let longestNode = nodes[0];

            for (let i = 1; i < nodes.length; i++) {
                if (nodes[i].data.title.length > longestNode.data.title.length) {
                longestNode = nodes[i];
                }
            }

            return longestNode;
        },
        averageTitleLength(nodes) {
            if (nodes.length === 0) {
                return 0;
            }
            const totalLength = nodes.reduce((sum, node) => sum + node.data.title.length, 0);
            return Math.round((totalLength / nodes.length).toFixed(2));
        },
        truncateTitle(title,n) {
            return title.length > n ? title.slice(0, n-3)+ '...' : title;
        }
    },
    /*computed: {
        zoomCSS () {
        	//return `transform: scale(${this.zoom})`;
            if(this.options.zoomable) return ;
            return this.zoom
        },

    }*/
};
</script>
<style>
.node circle {
    fill: #ccc;
    stroke: #ccc;
    stroke-width: 2px;
}

.node text {
    font-size: 12px;
}

.highlighted circle {
    fill: red;
    stroke: red;
    stroke-width: 2px;
}

.highlighted {
    stroke: red !important;
    stroke-width: 2px;
}

.link {
    stroke: green;
}
</style>